import React from "react";
import { IonCardHeader, IonBadge, IonCol } from "@ionic/react";
import styles from "./MainPageProduct.module.scss";
import classNames from "classnames/bind";
import { Product, ProductType } from "@core/types";
import { useConfig } from "../../../../../providers/config";
import { calculateDiscount } from "../../../../../utils/calculateDiscount";
import { checkProductNew } from "../../../../../utils/checkProductNew";
import { useCreatePriceMarkup } from "../../../../../utils/useCreatePriceMarkup";
import { Image } from "../../../../../components/Image/Image";
import { useProductCardActions } from "../../../../../providers/useProductActions/";
import { useTranslation } from "react-i18next";

interface CardHeaderProps {
  product: Product;
  lazyload?: boolean;
}

const cx = classNames.bind(styles);

const CardHeader = ({ product, lazyload }: CardHeaderProps) => {
  const config = useConfig();
  const { showProductDetail } = useProductCardActions();
  const { t } = useTranslation();
  const isProductNew = checkProductNew(product.dateCreated, config?.newProductDuration!);
  const priceHtml = useCreatePriceMarkup(product);

  const discount = calculateDiscount(
    product.type,
    product.onSale,
    product.price,
    product.regularPrice,
    product.priceHtml,
  );

  return (
    <IonCardHeader className={cx("ion-no-padding flex flex-col items-center")}>
      {isProductNew && <IonBadge className={cx(styles["new-product-label"])}>{t("NEW")}</IonBadge>}

      {!!discount && <IonBadge className={cx(styles["new-product-label"])}>{discount?.toFixed(0)}%</IonBadge>}

      <Image
        lazyLoad={lazyload}
        draggable={false}
        style={{ maxWidth: "100%", height: "100px" }}
        image={product?.images[0]}
        onClick={() => showProductDetail(product.id)}
      />

      <IonCol size="12" className={cx("ion-no-padding ion-text-start mt-1 md:mt-1")}>
        {(product.stockQuantity > 0 || product.type === ProductType.VARIABLE) && (
          <p
            className={cx(
              "price ellipsis",
              styles.price,
              styles.price__general,
              "block md:hidden",
              "main-page-price-amount",
            )}
            dangerouslySetInnerHTML={priceHtml}
          ></p>
        )}
        <div className="w-full line-clamp-2 text-wrap word-break text-[10px] text-black">{product.name}</div>
      </IonCol>
    </IonCardHeader>
  );
};

export default CardHeader;
